import type { InjectionKey } from 'vue'

export const KT_IS_IN_POPOVER: InjectionKey<boolean> =
	Symbol('KT_IS_IN_POPOVER')
